import React, { forwardRef } from "react";
import IconBase, { IconProps } from "frontend/icons/icon-base";

export const MondayBoardIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <IconBase
      ref={ref}
      renderPath={(color: string) => {
        return (
          <>
            <path
              d="M14.5 14.7998V16H5.5V14.7998H14.5ZM15.7998 13.5V7.5C15.7998 6.82688 15.2884 6.27357 14.6328 6.20703L14.5 6.2002H5.5C4.78203 6.2002 4.2002 6.78203 4.2002 7.5V13.5C4.2002 14.218 4.78203 14.7998 5.5 14.7998V16L5.24414 15.9873C4.06772 15.8677 3.13227 14.9323 3.0127 13.7559L3 13.5V7.5C3 6.20566 3.98361 5.14082 5.24414 5.0127L5.5 5H14.5L14.7559 5.0127C16.0164 5.14082 17 6.20566 17 7.5V13.5L16.9873 13.7559C16.8677 14.9323 15.9323 15.8677 14.7559 15.9873L14.5 16V14.7998C15.218 14.7998 15.7998 14.218 15.7998 13.5Z"
              fill={color}
            />
            <path
              d="M7.59961 15L7.58789 15.1211C7.53188 15.3944 7.2899 15.5996 7 15.5996C6.7101 15.5996 6.46811 15.3944 6.41211 15.1211L6.40039 15L6.40039 6C6.40039 5.66863 6.66863 5.40039 7 5.40039C7.33137 5.40039 7.59961 5.66863 7.59961 6L7.59961 15Z"
              fill={color}
            />
          </>
        );
      }}
      {...props}
      viewBox="0 0 20 20"
    >
      {props.children}
    </IconBase>
  );
});

MondayBoardIcon.displayName = "MondayBoardIcon";
